// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AssignUser_avatar__3Gdmw","userName":"AssignUser_userName__3lNSF","wrapper":"AssignUser_wrapper__4mAQD","list":"AssignUser_list__3Lbb7"};